// extracted by mini-css-extract-plugin
export var bottom = "styles-module--bottom--5a428";
export var bottomText = "styles-module--bottomText--d808f";
export var cartTop = "styles-module--cartTop--16dd3";
export var desktop = "1340px";
export var emptyCart = "styles-module--emptyCart--72be9";
export var emptyText = "styles-module--emptyText--2af6d";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var outOfStockWarning = "styles-module--outOfStockWarning--d6869";
export var product = "styles-module--product--6fc95";
export var products = "styles-module--products--28eb4";
export var scrollContent = "styles-module--scrollContent--d5d43";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var strikethrough = "styles-module--strikethrough--a88c5";
export var subtotal = "styles-module--subtotal--da774";
export var tablet = "769px";
export var warningIcon = "styles-module--warningIcon--4e104";